export default function getFormattedPhoneNumber(value = '') {
    const stringValue = String(value);
    const matchedValues = stringValue.match(/[0-9]/g);
    if (Array.isArray(matchedValues) && matchedValues.length === 10) {
        return `(${matchedValues.slice(0, 3).join('')})-${matchedValues.slice(3, 6).join('')}-${matchedValues.slice(6, 10).join('')}`;
    }
    return stringValue;
}
